import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.dataweave = bracketIndenting()
